// extracted by mini-css-extract-plugin
module.exports = {"container":"_3xO3EaIn","t1139Container":"vZXGRvrG","title":"_2owyDvNs","t1139Title":"_2eXB8g4o","content":"_1LLeCQdQ","footer":"_1LquYLQt"};